document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
  style: 'currency',
  currency: window.Shopify?.currency?.active || 'USD'
}).format(cents / 100);

const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
}[character]));

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const hero = document.querySelector('[data-print-hero]');
if (hero && !reducedMotion.matches) {
  let ticking = false;
  const compactHero = window.matchMedia('(max-width: 600px)').matches;
  const updateHero = () => {
    const bounds = hero.getBoundingClientRect();
    // Phones keep their normal document flow. The shorter travel maps native
    // page scroll to the print without a nested scroller or pinned scroll trap.
    const distance = compactHero
      ? Math.min(160, Math.max(120, window.innerHeight * 0.15))
      : Math.max(1, hero.offsetHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, -bounds.top / distance));
    const stage = hero.querySelector('.printer-stage');
    const mark = stage?.querySelector('.printer-stage__mark');
    const revealBottom = (1 - progress) * 65;
    const visibleEdge = 100 - revealBottom;
    stage?.style.setProperty('--progress', progress.toFixed(3));
    stage?.style.setProperty('--reveal-bottom', `${revealBottom.toFixed(3)}%`);
    if (stage && mark) {
      const stageBounds = stage.getBoundingClientRect();
      const markBounds = mark.getBoundingClientRect();
      const revealEdge = markBounds.top - stageBounds.top + (visibleEdge / 100) * markBounds.height;
      stage.style.setProperty('--print-edge-y', `${revealEdge.toFixed(2)}px`);
    }
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHero);
      ticking = true;
    }
  }, { passive: true });
  window.addEventListener('resize', updateHero, { passive: true });
  updateHero();
}

const revealObserver = 'IntersectionObserver' in window && !reducedMotion.matches
  ? new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    }), { rootMargin: '0px 0px -8% 0px' })
  : null;
document.querySelectorAll('.reveal').forEach((element) => revealObserver ? revealObserver.observe(element) : element.classList.add('is-visible'));

const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
menuToggle?.addEventListener('click', () => {
  const open = menuToggle.getAttribute('aria-expanded') === 'true';
  menuToggle.setAttribute('aria-expanded', String(!open));
  mobileMenu.hidden = open;
});

document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.target.form.submit());

const cartDrawer = document.querySelector('[data-cart-drawer]');
const renderCart = async () => {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart unavailable');
  const cart = await response.json();
  document.querySelectorAll('[data-cart-badge]').forEach((badge) => badge.textContent = cart.item_count);
  document.querySelector('[data-cart-count]').textContent = `(${cart.item_count})`;
  const body = document.querySelector('[data-cart-body]');
  const foot = document.querySelector('[data-cart-foot]');
  if (!cart.items.length) {
    body.innerHTML = '<p class="cart-empty">Your cart is empty</p>';
    foot.hidden = true;
    return cart;
  }
  body.innerHTML = cart.items.map((item, index) => `
    <article class="drawer-line">
      <a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image || '')}&width=160" width="80" height="96" alt=""></a>
      <div><h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>${item.variant_title ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}<p>${money(item.final_line_price)}</p><div class="drawer-quantity" aria-label="Quantity for ${escapeHtml(item.product_title)}"><button type="button" data-cart-quantity="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><span aria-live="polite">${item.quantity}</span><button type="button" data-cart-quantity="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div></div>
      <button type="button" data-cart-remove="${index + 1}">Remove</button>
    </article>`).join('');
  document.querySelector('[data-cart-total]').textContent = money(cart.total_price);
  foot.hidden = false;
  return cart;
};

document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async (event) => {
  event.preventDefault();
  try {
    await renderCart();
    cartDrawer?.showModal();
  } catch (error) {
    window.location.assign(button.href);
  }
}));
document.querySelector('[data-cart-close]')?.addEventListener('click', () => cartDrawer.close());
cartDrawer?.addEventListener('click', (event) => { if (event.target === cartDrawer) cartDrawer.close(); });
document.querySelector('[data-cart-body]')?.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cart-remove], [data-cart-quantity]');
  if (!button) return;
  button.disabled = true;
  const line = Number(button.dataset.cartRemove || button.dataset.cartQuantity);
  const quantity = button.dataset.cartRemove ? 0 : Number(button.dataset.quantity);
  await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ line, quantity })
  });
  await renderCart();
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const form = root.querySelector('[data-product-form]');
  if (!form) return;
  const fallbackSelect = form.querySelector('[data-no-js-variant]');
  const variantId = form.querySelector('[data-variant-id]');
  if (fallbackSelect && variantId) { fallbackSelect.disabled = true; variantId.disabled = false; }
  const variants = JSON.parse(form.querySelector('[data-product-json]').textContent);
  const optionInputs = [...form.querySelectorAll('[name^="option-"]')];
  const findVariant = () => {
    const selected = optionInputs.filter((input) => input.checked).map((input) => input.value);
    return variants.find((variant) => variant.options.every((option, index) => option === selected[index]));
  };
  const syncVariant = () => {
    const variant = findVariant();
    variantId.value = variant?.id || '';
    root.querySelector('[data-product-price]').textContent = variant ? money(variant.price) : '';
    const add = form.querySelector('[data-add-button]');
    add.disabled = !variant?.available;
    add.querySelector('span').textContent = variant?.available ? 'Add to cart' : variant ? 'Sold out' : 'Unavailable';
    if (variant) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  };
  optionInputs.forEach((input) => input.addEventListener('change', syncVariant));
  if (optionInputs.length) syncVariant();
  form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    const input = form.elements.quantity;
    input.value = Math.max(1, Number(input.value) - 1);
  });
  form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    const input = form.elements.quantity;
    input.value = Math.max(1, Number(input.value) + 1);
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[data-add-button]');
    button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add this item');
      await renderCart();
      cartDrawer?.showModal();
    } catch (error) {
      window.alert(error.message);
    } finally { button.disabled = false; }
  });
});

document.querySelectorAll('[data-estimator]').forEach((root) => {
  const form = root.querySelector('[data-estimator-form]');
  const total = root.querySelector('[data-estimator-total]');
  const breakdown = root.querySelector('[data-estimator-breakdown]');
  const estimateField = root.querySelector('[data-estimate-field]');
  const clearEstimate = () => {
    root.querySelector('.estimator__result')?.classList.remove('is-fresh');
    total.textContent = '-';
    breakdown.textContent = 'Enter verified slicer values to calculate.';
    if (estimateField) estimateField.value = '';
  };
  form?.addEventListener('input', clearEstimate);
  form?.addEventListener('change', clearEstimate);
  const validate = (field, allowZero) => {
    const raw = field.value.trim();
    const error = root.querySelector(`[data-error="${field.name}"]`);
    let message = '';
    if (raw === '') message = 'Required.';
    else if (!Number.isFinite(Number(raw))) message = 'Enter a valid number.';
    else if (Number(raw) < 0 || (!allowZero && Number(raw) === 0)) message = allowZero ? 'Enter zero or a positive number.' : 'Enter a value greater than zero.';
    error.textContent = message;
    field.setAttribute('aria-invalid', String(Boolean(message)));
    return !message;
  };
  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    const hoursValid = validate(form.elements.hours, true);
    const gramsValid = validate(form.elements.grams, false);
    const minutesValid = validate(form.elements.minutes, true);
    if (!hoursValid || !gramsValid || !minutesValid) {
      total.textContent = '—';
      breakdown.textContent = 'Correct the highlighted fields to calculate.';
      if (estimateField) estimateField.value = '';
      return;
    }
    const hours = Number(form.elements.hours.value);
    const grams = Number(form.elements.grams.value);
    const minutes = Number(form.elements.minutes.value);
    const printCents = (hours / 6) * 1000;
    const filamentCents = grams < 500 ? 500 : 1000;
    const designCents = (minutes / 20) * 1000;
    const orderCents = form.elements.special_filament.checked ? 799 : 0;
    const estimateCents = Math.round(printCents + filamentCents + designCents + orderCents);
    total.textContent = money(estimateCents);
    breakdown.textContent = `Print ${money(printCents)} + filament ${money(filamentCents)} + design ${money(designCents)}${orderCents ? ` + special-order filament ${money(orderCents)}` : ''}.`;
    const result = root.querySelector('.estimator__result');
    result?.classList.remove('is-fresh');
    window.requestAnimationFrame(() => result?.classList.add('is-fresh'));
    if (estimateField) estimateField.value = `${money(estimateCents)} planning estimate; ${hours} print hours; ${grams}g filament; ${minutes} design minutes; special-order filament: ${orderCents ? 'yes' : 'no'}`;
  });
  root.querySelector('[data-estimator-unsure]')?.addEventListener('click', () => root.querySelector('#CustomInquiry')?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth' }));
});
